<template>
  <div>
    <b-row>
      <b-col cols="12">
        <subjects-filter :get-report-data="getData" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <b-card>
            <app-collapse type="border">
              <app-collapse-item
                title="Genel Toplam"
                is-visible
              >
                <list-card
                  :data-list="subjects.grandTotals"
                  :chart-data="subjects.chartGrandTotals"
                />
              </app-collapse-item>
              <template v-for="item in subjects.data">
                <app-collapse-item
                  v-if="item.subjects.length > 0"
                  :key="item.id"
                  :title="item.title"
                >
                  <list-card
                    v-if="item.subjects.length > 0"
                    :key="item.id"
                    :card-title="item.title"
                    :data-list="item.subjects"
                    :chart-data="item.chartData"
                  />
                </app-collapse-item>
              </template>
            </app-collapse>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import SubjectsFilter from '@/views/Crm/FilterCards/SubjectsFilter.vue'
import ListCard from '@/views/Crm/Components/ListCard.vue'

export default {
  name: 'IndexPage',
  components: {
    AppCollapse,
    AppCollapseItem,
    LoadingCard,
    SubjectsFilter,
    ListCard,
    BRow,
    BCol,
    BCard,
  },
  computed: {
    loading() {
      return this.$store.getters['crmSubjectsReports/loading']
    },
    subjects() {
      return this.$store.getters['crmSubjectsReports/subjects']
    },
    subjectParams() {
      return this.$store.getters['crmSubjectsReports/subjectParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('crmSubjectsReports/getSubjects', this.subjectParams)
    },
  },
}
</script>
